import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { environment } from "environments/environment";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import { UserSessionService } from "./user-session.service";
import { URLS } from "./api.service";
import { UserStorageService } from "./user-storage.service";
import { Tro } from "app/models/Tro";

declare var $: any;

@Injectable()
export class TroService {
  apiService: any;

  constructor() {}

  private httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  getGrupoTro() {
    this.apiService
      .get(
        URLS.TRO.GET_LISTAR_GRUPO_TIPO_OCORRENCIA,
        "",
        environment.urlLaravel
      )
      .subscribe(
        function (data) {
          console.log(data);
          return data;
        },
        function (error) {
          console.log(error);
        }
      );
  }
  getSubGrupoTro() {
    this.apiService
      .get(
        URLS.TRO.GET_LISTAR_GRUPO_TIPO_OCORRENCIA,
        "",
        environment.urlLaravel
      )
      .subscribe(
        function (data) {
          console.log(data);
          return data;
        },
        function (error) {
          console.log(error);
        }
      );
  }

  getSolicitacaoPorProtocolo(protocolo) {
    this.apiService
      .get(
        URLS.SOLICITACOES.GET_SOLICITACOES,
        protocolo,
        environment.urlLaravel
      )
      .subscribe(
        function (data) {
          console.log(data);
          return data;
        },
        function (error) {
          console.log(error);
        }
      );
  }

  getTros(): Observable<Tro[]> {
    return this.apiService
      .get(URLS.TRO.GET_TROS, "", environment.urlLaravel)
      .subscribe(
        function (data) {
          console.log(data);
          return data;
        },
        function (error) {
          console.log(error);
        }
      );
  }

  editarTro(): Observable<any[]> {
    return this.apiService
      .get(URLS.TRO.GET_TROS, "", environment.urlLaravel)
      .subscribe(
        function (data) {
          console.log(data);
          return data;
        },
        function (error) {
          console.log(error);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tro.service.ts